import React, { FC } from 'react'
import { makeStyles, Box, Typography, BoxProps as MuiBoxProps } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

const useSidebarLabelStyles = makeStyles({
  label: {
    color: brandColors.coolGray8,
  },
})

interface ISidebarLabelProps {
  BoxProps?: MuiBoxProps
}

export const SidebarLabel: FC<ISidebarLabelProps> = ({ children, BoxProps = {} }) => {
  const classes = useSidebarLabelStyles()
  return (
    <Box {...BoxProps}>
      <Typography variant='subtitle1' className={classes.label}>
        {children}
      </Typography>
    </Box>
  )
}
